export default {
    namespaced: true,
    state() {
        return {
            storyBoard:{}
        };
    },
    actions: {
      async getStoryboardFromServer(context,url){
            if(!url) throw new Error([]);
            try{
                let res = await fetch(url);
                let data = await res.json();
                context.commit('addStoryBoard',data);
                console.log('server data....',data);
                return data;
            }catch(error){
                console.error(
                    `[getStoryboardFromServer][Store][Error occured while getting asset info--->${error}]`
                  );
                if (error.response) {
                    if (error.response.status == 401){
                      return context.dispatch("users/logOutFromServer", {},{root:true})
                    }
                    else {
                      error.response.data.statusCode = error.response.status
                      return error.response.data
                    }
                  }
                 throw new Error([]);
            }
       }
    },
    getters: {
    },
    mutations: {
        addStoryBoard(state,data){
            console.log('state,data',state,data);
            state.storyBoard = data;
        }
    },
};